module.exports = __webpack_public_path__ + "img/phone.72a5688a.png";